<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('system', ['routerStatusRedirect']),
    ...mapState('contract', ['limitTransaction']),
  },
  async created() {
    if (!this.limitTransaction) {
      await this.getLimitTransaction()
    }

    // truthOrFalsehoodOfCertificateOfIncomeAmount
    console.log(`status check ${this.resultName}`)
    if (this.limitTransaction) {
      const name = 'apply/before'
      if ([name].includes(this.$route.name) === false && this.routerStatusRedirect) {
        return await this.$router.replace({ name })
      }
      return
    }

    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
  methods: {
    ...mapActions('contract', ['getLimitTransaction']),
  },
}
</script>
